import React from 'react';
import { linkifyEntityIds } from '@chatsdet/ids';
import { Markdown, type MarkdownProps } from '@chatsdet/ui';

// Re-exported for existing imports/tests — the implementation is the single
// shared source in @chatsdet/ids (also used server-side for entity resolution).
export { linkifyEntityIds } from '@chatsdet/ids';

export function EntityLinkMarkdown({ children, ...props }: MarkdownProps): React.ReactElement {
  return <Markdown {...props}>{linkifyEntityIds(children)}</Markdown>;
}
